export default function IndustryLogistic() {
  return (
    <>
      <section className="industry-logistic">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="heading center-heading">Why Choose Your <span className="gradiant-color">Own <br /> Logistics Optimization</span> Solution?</h2>
              <p className="sub-heading">The logistics industry is rapidly expanding, making it the ideal time to invest in tailored logistics solutions. Developing a  <br />branded logistics mobile app can unlock tremendous opportunities for growth and profitability.
              </p>
            </div>

            <div className="col-lg-6">
              <div className="industry-left-box">
                <img loading="lazy" src="./assets/home/industry-logistic-1.webp" alt="industry" className="img-responsive" />
                <div>
                  <span>Increased Market Share</span>
                  <p>Logistics and trucking dominate with 35% of the market. </p>
                </div>
              </div>
              <div className="industry-left-box">
                <img loading="lazy" src="./assets/home/industry-logistic-2.webp" alt="industry" className="img-responsive" />
                <div>
                  <span>Enhanced Funding Opportunities</span>
                  <p>Startups like 'Sendy' raised $20M in 2020, showcasing strong investor interest.</p>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="industry-right-box">
                <img src="./assets/home/industry-logistic-3.webp" alt="industry" className="img-responsive" />
                <div>
                  <span>Massive Growth Potential</span>
                  <p>The logistics market is projected to grow by $287.1M by 2024.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
